<template>
  <div id="pripady-table-container-wrapper">
    <message-box v-model="warningMessage.open" title="Zrušiť prípad" text="Naozaj chcete zrušiť tento prípad?"
      :action="cancelPripad" persistent yes-no />
    <v-container id="pripady-table-wrapper" class="pa-0">
      <v-data-table ref="vDataTable" v-model="selected" :headers="headers" :items="items" hide-default-footer
        :page.sync="page" :items-per-page="9" @page-count="pageCount = $event" :single-select="false"
        :single-expand="false" :expanded.sync="expanded" @click:row="rowClicked" item-key="cislo_obch_pripadu"
        :loading="loading" loadingText="Načítavam dáta ..." @item-expanded="itemExpanded">
        <template v-slot:[`item.id_stavu`]="{ item }">
          <status :state="item.id_stavu" />
        </template>

        <template v-slot:[`item.najomca`]="{ item }">
          <div class="text-overflow-dots">{{ item.najomca }}</div>
        </template>

        <template v-slot:[`item.rozpracovany_flag`]="{ item }">
          <!-- <v-icon v-if="item.rozpracovany_flag" :size="20">mdi-tools</v-icon> -->
          {{ item.rozpracovany_flag ? 'Áno' : '' }}
        </template>

        <template v-slot:[`item.datum_vytvorenia`]="{ item }">
          {{ item.datum_vytvorenia ? item.datum_vytvorenia.formatDate() : '' }}
        </template>

        <template v-slot:[`item.datum_modifikacie`]="{ item }">
          {{ item.datum_modifikacie ? item.datum_modifikacie.formatDate() : '' }}
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" :class="{
      'ma-0 pa-0': true,
      'expanded-closing': !transitioned[getItemId(item)],
    }" style="height: auto">
            <v-expand-transition>
              <div v-show="transitioned[getItemId(item)]">
                <v-data-table id="table-predmety" :disable-pagination="true" hide-default-footer
                  :headers="predmety.headers" :items="item.predmety" :loading="item.loading"
                  loadingText="Načítavam dáta ..." :key="renderKey">
                  <template v-slot:[`item.typ`]="{ item }">
                    {{ item.typ }}
                    <span>({{ item.typ_predmetu_sufix }})</span>
                  </template>
                  <template v-slot:[`item.oc`]="{ item }">
                    {{ item.oc ? item.oc.toEurString() : null }}
                  </template>
                  <template v-slot:[`item.akcie`]="{ item }">
                    <v-menu content-class="pripady-table-menu" transition="slide-x-transition" offset-x left
                      close-delay="100" v-model="item.openMenu">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn dark icon v-bind="attrs" @click.stop="loadMenuPredmetSettings(item)">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <v-list id="pripady-table-menu-list" elevation="1">
                        <v-list-item link dense v-for="(m, i) in item.menu" :key="i" :class="m.color"
                          :disabled="!m.isEnabled" @click="actionClick(m, item)">
                          <v-list-item-icon class="mr-4">
                            <v-icon v-text="m.icon" class="material-icons-outlined icon-block" size="24"></v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>{{ m.nazov }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
              </div>
            </v-expand-transition>
          </td>
        </template>

        <template v-slot:[`item.akcie`]="{ item }">
          <v-menu content-class="pripady-table-menu" transition="slide-x-transition" offset-x left close-delay="100"
            v-model="item.openMenu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" @click.stop="loadMenuPripadSettings(item)">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list id="pripady-table-menu-list" elevation="1">
              <v-list-item link dense v-for="(m, i) in item.menu" :key="i" :class="m.color" :disabled="!m.isEnabled"
                @click="actionClick(m, item)">
                <v-list-item-icon class="mr-4">
                  <v-icon v-text="m.icon" class="material-icons-outlined icon-block" size="24"></v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ m.nazov }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
      <v-pagination class="table-nav" v-model="page" :length="pageCount"></v-pagination>
      <v-dialog v-model="zmenaStrediskaDialog.open" overlay-color="#000" overlay-opacity="0.66" persistent eager
        max-width="500">
        <v-card>
          <v-card-title class="d-flex justify-space-between">
            <span class="gs100 f16">Zmena lokality pobočky</span>
            <v-btn icon @click="zmenaStrediskaDialog.open = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="f16 white100">
            <v-combobox label="Predajca" append-icon="mdi-chevron-down" outlined class="dynamic-input-control"
              v-model="zmenaStrediskaDialog.value" :items="strediska" :loading="zmenaStrediskaDialog.loading"
              item-text="display_member" item-value="value_member" return-object />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn-secondary" @click="zmenaStrediskaDialog.open = false"> Zrušiť </v-btn>
            <v-btn class="btn-primary" @click="saveStredisko()"> Zmeniť </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import protectedAxios from '../../auth/axios';
import Status from '../basic/Status.vue';
import { pripadLinkMixin } from '../../mixins/pripadLinkMixin';
import { pripadActionsMixin } from '../../mixins/pripadActionsMixin';
import MessageBox from '../basic/MessageBox.vue';

export default {
  mixins: [pripadLinkMixin, pripadActionsMixin],
  components: { Status, MessageBox },

  methods: {
    rowClicked(item, props) {
      this.toggleExpand(props);
    },

    duplikovatPredmet(newId, cisloPredmetu) {
      protectedAxios
        .post(`/pripady/${newId}/predmety/${cisloPredmetu}/new-clone`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          if (res.data) {
            this.redirectToEditPripad(res.data);
          }
        });
    },

    itemExpanded(row) {
      //predmety ulozim do priamo pod pripad
      if (row.value && !row.item.predmety) {
        row.item.loading = true;
        setTimeout(() => {
          this.loadPredmety(row.item);
        }, 500);
      }
    },

    //COLLAPSING
    getItemId(item) {
      return item.cislo_obch_pripadu; // Must be uid of record (would be nice if v-data-table exposed a "getItemKey" method)
    },
    toggleExpand(props) {
      const item = props.item;
      const id = this.getItemId(item);

      if (props.isExpanded && this.transitioned[id]) {
        // If we're expanded and not in the process of closing, close
        this.closeExpand(item, props);
      } else {
        // If we're closed or in the process of closing, expand
        // Stop us from closing if a close transition was started
        clearTimeout(this.closeTimeouts[id]);
        // Tell v-data-table to add the expansion content for the item
        props.expand(true);
        // Show expansion content with transition animation after it's had time to get added to the DOM
        this.$nextTick(() => this.$set(this.transitioned, id, true));
      }
    },
    closeExpand(item, props) {
      const id = this.getItemId(item);
      // Mark that this item is in the process of closing
      this.$set(this.transitioned, id, false);
      // Remove expansion content from DOM after transition animation has had enough time to finish
      this.closeTimeouts[id] = setTimeout(() => props.expand(false), 200);
    },
    loadData(filter) {
      this.loading = true;
      this.items = [];
      this.selected = [];
      this.expanded = [];
      this.transitioned = [];
      this.closeTimeouts = [];

      let urlParams = protectedAxios.generateUrlParameters(filter);

      protectedAxios
        .get(`pripady${urlParams}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          let items = res.data ? res.data : [];

          this.items = items.map(i => {
            let obj = i;
            obj.menu = JSON.parse(JSON.stringify(this.menuPripad));
            obj.openMenu = false;
            return obj;
          });
        })
        .catch(e => {
          console.error(e);
          this.items = [];
        })
        .finally(() => (this.loading = false));
    },
    actionClick(menuItem, pripadItem) {
      switch (menuItem.action) {
        //PRIPAD
        case 'pridat_dokumenty_pripad':
          this.redirectToUploadDokumentov(
            pripadItem.new_id,
            '0',
            '',
            'obchodne-pripady'
          );
          break;
        case 'tlacit_pripad':
          this.redirectToTlacDokumentov(pripadItem.new_id);
          break;
        case 'edit_pripad':
          this.redirectToEditPripad(pripadItem.new_id);
          break;
        case 'edit_najomca':
          this.redirectToEditNajomca(pripadItem.new_id);
          break;
        case 'edit_stav':
          this.openCancelWarning(pripadItem.new_id);
          break;
        case 'sumar':
          this.redirectToSumarPredmet(pripadItem.new_id);
          break;

        //PREDMET
        case 'pridat_dokumenty_predmet':
          this.redirectToUploadDokumentov(
            pripadItem.new_id,
            pripadItem.cislo_predmetu,
            pripadItem.predmet,
            'sumar-predmet'
          );
          break;
        case 'tlacit_predmet':
          this.redirectToTlacDokumentovPredmet(
            pripadItem.new_id,
            pripadItem.cislo_predmetu
          );
          break;
        case 'duplikovat_predmet':
          this.duplikovatPredmet(pripadItem.new_id, pripadItem.cislo_predmetu);
          break;
        case 'preberaci_protokol':
          this.redirectToPreberaciProtokol(
            pripadItem.new_id,
            pripadItem.cislo_predmetu
          );
          break;
        case 'sumar_predmet':
          this.redirectToSumarPredmet(pripadItem.new_id);
          break;
        case 'zmena_strediska':
          this.openZmenaStrediskaDialog(pripadItem);
          break;
        default:
          break;
      }
    },
    loadPredmety(pripadItem) {
      protectedAxios
        .get(`/pripady/${pripadItem.new_id}/predmety`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          let items = res.data ? res.data : [];

          pripadItem.predmety = items.map(i => {
            let obj = i;
            obj.menu = JSON.parse(JSON.stringify(this.menuPredmet));
            obj.new_id = pripadItem.new_id;
            obj.openMenu = false;
            return obj;
          });
        })
        .catch(e => {
          console.error(e);
          this.items = [];
        })
        .finally(() => {
          pripadItem.loading = false;
          this.renderKey++;
        });
    },
    async loadMenuPripadSettings(item) {
      if(!item.openMenu){
      await protectedAxios
        .get(`/pripady/${item.new_id}/menu/0`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          if (res.data) {
            res.data.forEach(s => {
              if (!s.is_visible) return
              const mItem = item.menu.find(m => m.action === s.value_member);
              this.$set(mItem, 'nazov', s.display_member);
              this.$set(mItem, 'isEnabled', s.is_enabled);
              this.$set(mItem, 'por', s.por);
            });
          }
          item.menu.sort((a, b) => a.por - b.por);
          item.openMenu = true;
        });
      }else{
        item.openMenu = false;
      }
    },
    async loadMenuPredmetSettings(item, onEvent) {
      if(!item.openMenu){
      await protectedAxios
        .get(
          `/pripady/${item.new_id}/predmety/${item.cislo_predmetu}/menu/0`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          if (res.data) {
            res.data.forEach(s => {
              if (!s.is_visible) return
              const mItem = item.menu.find(m => m.action === s.value_member);
              this.$set(mItem, 'nazov', s.display_member);
              this.$set(mItem, 'isEnabled', s.is_enabled);
              this.$set(mItem, 'por', s.por);
            });
            item.menu.sort((a, b) => a.por - b.por);
            item.openMenu = true;
          }
        });
      }else{
        item.openMenu = false;
      }
    },
    openZmenaStrediskaDialog(item) {
      this.zmenaStrediskaDialog.open = true;
      this.zmenaStrediskaDialog.predmet = item;
      protectedAxios
        .get(
          `/pripady/${item.new_id}/predmety/${item.cislo_predmetu}/strediska`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          if (res.data) {
            this.strediska = res.data;
            this.zmenaStrediskaDialog.value = this.strediska.find(s => s.control_value == 1);
          }
        })
        .finally(() => {
          this.zmenaStrediskaDialog.loading = false;
        });
    },
    saveStredisko() {
      if (this.zmenaStrediskaDialog.value) {
        protectedAxios
          .post(
            `/pripady/${this.zmenaStrediskaDialog.predmet.new_id}/predmety/${this.zmenaStrediskaDialog.predmet.cislo_predmetu}/stredisko`,
            {
              IdStrediska: this.zmenaStrediskaDialog.value.value_member,
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(res => {
            this.zmenaStrediskaDialog.open = false;
          });
      }
    },
    reloadData(){
      this.$emit('reloadTable');
    }
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      selected: [],
      expanded: [],
      singleExpand: false,
      transitioned: [],
      closeTimeouts: [],
      loading: false,
      renderKey: 0,
      menuPripad: [
        {
          nazov: 'Editovať',
          icon: 'mdi-pencil-outline',
          action: 'edit_pripad',
        },
        {
          nazov: 'Upraviť nájomcu',
          icon: 'mdi-account-outline',
          action: 'edit_najomca',
        },
        {
          nazov: 'Zobraziť sumár',
          icon: 'summarize',
          action: 'sumar',
        },
        {
          nazov: 'Pridať',
          icon: 'mdi-upload-outline',
          action: 'pridat_dokumenty_pripad',
        },
        {
          nazov: 'Zmeniť stav',
          icon: 'mdi-checkbox-blank-circle-outline',
          action: 'edit_stav',
        },
        { nazov: 'Tlačiť', icon: 'printer', action: 'tlacit_pripad' },
      ],
      menuPredmet: [
        {
          nazov: 'Pridať',
          icon: 'mdi-upload-outline',
          action: 'pridat_dokumenty_predmet',
        },
        { nazov: 'Tlačiť', icon: 'printer', action: 'tlacit_predmet' },
        {
          nazov: 'Zobraziť sumár',
          icon: 'summarize',
          action: 'sumar_predmet',
        },
        {
          nazov: 'Preberací protokol',
          icon: 'mdi-text-box-check-outline',
          action: 'preberaci_protokol',
        },
        {
          nazov: 'Duplikovať',
          icon: 'file_copy',
          action: 'duplikovat_predmet',
        },
        {
          nazov: 'Zmena strediska',
          icon: '$change_centrum',
          action: 'zmena_strediska',
        },
      ],
      headers: [
        { text: 'OBC ID#', value: 'cislo_obch_pripadu', width: 140 },
        { text: 'Nájomca', value: 'najomca', width: 240 },
        { text: 'Status', value: 'id_stavu' },
        { text: 'Rozpracovaný', value: 'rozpracovany_flag' },
        { text: 'Výtvorené', value: 'datum_vytvorenia' },
        { text: 'Modifikované', value: 'datum_modifikacie' },
        { text: 'Modifikoval', value: 'modifikoval' },
        { text: 'Akcie', value: 'akcie', sortable: false },
      ],
      items: [],
      predmety: {
        headers: [
          { text: 'Predmet', value: 'predmet' },
          { text: 'VIN', value: 'vin' },
          { text: 'Obstarávacia cena', value: 'oc' },
          { text: 'Typ predmetu', value: 'typ' },
          { text: 'Akcie', value: 'akcie', sortable: false },
        ],
        items: [],
      },
      zmenaStrediskaDialog: {
        open: false,
        value: null,
        loading: false,
        predmet: null,
      },
      strediska: [],
    };
  },
};
</script>
<style lang="sass">
#pripady-table-menu-list
  min-width: 170px
.text-overflow-dots
  width: 240px
  overflow: hidden
  display: block
  text-overflow: ellipsis
  white-space: nowrap
</style>
